import "./Checkbox.scss";

export function Checkbox({ text, onClick, ...props }) {
  const click = (e) => {
    e.stopPropagation();
    onClick(e);
  };

  const change = (e) => {
    e.stopPropagation();
    onClick(e);
  };

  return (
    <div className="checkbox" onClick={click}>
      <input
        type="checkbox"
        onChange={change}
        onClick={(e) => e.stopPropagation()}
        {...props}
      />
      <label>{text}</label>
    </div>
  );
}
